import { SelectDataType } from "@sso/components/Form";
import { OrderStatus, UserRole } from "@sso/constant";
import { PaymentType, SearchFieldKeys, TableColumn } from "@sso/types";

const orderStatusOptions: SelectDataType[] = [
  { key: OrderStatus.OPEN, value: OrderStatus.OPEN, label: "Payment pending" },
  { key: OrderStatus.COMPLETE, value: OrderStatus.COMPLETE, label: "Paid" },
];

const paymentTypeOptions: SelectDataType[] = [
  { key: PaymentType.OneOffPayment, value: PaymentType.OneOffPayment, label: "One off Payment" },
  { key: PaymentType.RecurringPayment, value: PaymentType.RecurringPayment, label: "Recurring Payment" },
  { key: PaymentType.PaymentOnAccount, value: PaymentType.PaymentOnAccount, label: "Payment on Account" },
  { key: PaymentType.Free, value: PaymentType.Free, label: "Free" },
];

export const orderTableColumns: TableColumn<string>[] = [
  {
    name: "Product",
    field: "SoftwareName",
    sortable: true,
    search: { type: SearchFieldKeys.TEXT },
  },
  {
    name: "User",
    field: "FullName",
    search: { type: SearchFieldKeys.TEXT },
    access: [UserRole.ORG_ADMIN, UserRole.ADMINISTRATOR],
    sortable: true,
  },
  {
    name: "Organisation",
    field: "OrganisationName",
    sortable: true,
    search: { type: SearchFieldKeys.TEXT },
    access: [UserRole.ADMINISTRATOR],
  },
  {
    name: "Created",
    field: "CreatedDate",
    sortable: true,
    search: { type: SearchFieldKeys.DATE_RANGE },
  },
  {
    name: "Status",
    field: "Status",
    sortable: true,
    search: { type: SearchFieldKeys.SELECT, options: orderStatusOptions },
  },
  {
    name: "Payment Mode",
    field: "PaymentMode",
    sortable: true,
    search: { type: SearchFieldKeys.SELECT, options: paymentTypeOptions },
  },
  {
    name: "Value",
    field: "total",
    sortable: true,
  },
];
